import { useEffect } from 'react';

export default function useOGMeta({ title, description, image, url }) {
  useEffect(() => {
    const setMeta = (property, content) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content || '');
    };

    if (title) {
      document.title = title;
      setMeta('og:title', title);
    }
    if (description) setMeta('og:description', description);
    if (image) setMeta('og:image', image);
    if (url) setMeta('og:url', url);
    setMeta('og:type', 'website');

    return () => {
      document.title = 'PhotoVendo';
    };
  }, [title, description, image, url]);
}
